<template>
    <span v-if="competitor.id > 0" :class="{ 'has-text-warning': duplicatedPair }">
        <small>{{ competitor.id }}</small>
        <span class="clarity-mask" style="margin-left: 3px">{{ competitor.firstName }} {{ competitor.lastName }}</span>
    </span>
    <span v-else class="clarity-mask">
        {{ competitor.firstName }}
    </span>
</template>

<script setup lang="ts">
    import { Competitor } from "../Common/Competitors/types";

    defineProps<{
        competitor: Competitor;
        duplicatedPair?: boolean;
    }>();
</script>

<style scoped></style>
